/** Business outcomes are independent of a graceful hang-up or successful authentication. */
export const CALL_RESULT_LABELS = {
  'ticket-created': 'Ticket created',
  'information-added': 'Information added',
  'closure-requested': 'Closure requested',
  closed: 'Closed',
  escalated: 'Escalated',
  'forwarded-browser': 'Forwarded to human',
  'forwarded-phone': 'Forwarded to human',
} as const;
export type CallResultAction = keyof typeof CALL_RESULT_LABELS;
export type CallResult = {
  state: 'succeeded' | 'unsuccessful' | 'in-progress' | 'transfer-pending' | 'transfer-unconfirmed' | 'no-conversation';
  actions: CallResultAction[];
};
